import RequestManager from "../../API";
import api from "../../utils/api";
export const change_password = (params?: any) => async (dispatch: any) => {
  const response: any = await RequestManager.postRequest(
    dispatch,
    api.CHANGE_PASSWORD,
    "",
    params,
    true
  );
  if (response) {
    return response;
  }
};
export const forgot_password = (params: any) => async (dispatch: any) => {
  const response: any = await RequestManager.postRequest(
    dispatch,
    api.FORGOT_PASSWORD,
    "",
    params
  );
  if (response) {
    return response;
  }
};


export const resetPassword =
(query?: any) => async (dispatch: any, getState: any) => {
  const response: any = await RequestManager.postRequest(
    dispatch,
    api.RESET_PASSWORD,
    "",
    query,
  );
  if (response) {
    return response;
  }
};
